/**
* DevExpress Dashboard (_calculated-field.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { replaceExpressionParametersPrefix } from '../../internal/_expression-utils';
import { itemType, name } from '../../metadata/_base-metadata';
export let calcFieldDataMember = { propertyName: 'dataMember', modelName: '@DataMember' };
export let calcFieldExpression = { propertyName: 'expression', modelName: '@Expression',
    from: (expressionStr) => {
        return replaceExpressionParametersPrefix(expressionStr);
    }, defaultVal: '' };
export let calcFieldExpressionEditable = { propertyName: 'expressionEditable', displayName: 'DashboardStringId.CalculationTypeExpression' };
export let calculatedFieldType = {
    propertyName: 'fieldType', modelName: '@DataType', displayName: 'DevExpressWebStringId.CalculatedFieldDataType', defaultVal: 'String', simpleFormAdapterItem: 'selectBoxEditor', values: {
        'Auto': 'DashboardStringId.CalculatedFieldTypeAuto',
        'String': 'DashboardStringId.CalculatedFieldTypeString',
        'Integer': 'DashboardStringId.CalculatedFieldTypeLong',
        'Double': 'DashboardStringId.CalculatedFieldTypeDouble',
        'Decimal': 'DashboardStringId.CalculatedFieldTypeDecimal',
        'Boolean': 'DashboardStringId.CalculatedFieldTypeBoolean',
        'DateTime': 'DashboardStringId.CalculatedFieldTypeDateTime',
        'Object': 'DashboardStringId.CalculatedFieldTypeObject'
    }
};
export let calculatedFieldSerializationsInfo = [itemType, name, calcFieldExpression, calculatedFieldType, calcFieldDataMember];
